import { ia } from 'lib/helpers/utility';

export const splitInvoicesByDate = (invoices) => {
  const now = new Date();

  const pastInvoices = [];
  const upcomingInvoices = [];

  invoices.forEach(([invoiceId, invoice]) => {
    const invoiceDate = new Date(invoice.dateofservice);

    if (invoiceDate < now) {
      pastInvoices.push([invoiceId, invoice]);
    } else {
      upcomingInvoices.push([invoiceId, invoice]);
    }
  });

  return {
    pastInvoices,
    upcomingInvoices
  };
};

export const updateShowFlag = (array, status, checked) => {
  if (!ia(array)) return array;

  return array.map((entry) =>
    entry.invoiceStatus === status ? { ...entry, show: checked } : entry
  );
};

export const updateShowFlagByDate = (array, status, date, checked, isPast) => {
  if (!ia(array)) return array;

  return array.map((entry) => {
    const isStatusMatch = entry.invoiceStatus === status;
    const isDateMatch = isPast ? entry.dateofservice <= date : entry.dateofservice > date;

    return isStatusMatch && isDateMatch ? { ...entry, show: checked } : entry;
  });
};

export const getFilteredInvoices = (invoices, checked) => {
  return invoices.filter(([_, invoice]) => invoice.rows.some((row) => row.show === checked));
};

export const mergeAllRows = (data) => {
  if (!ia(data)) return [];

  return data.flatMap(([_, invoice]) => invoice.rows || []);
};
